/* unplugin-vue-components disabled */import { render } from "./SearchCategoryTitle.vue?vue&type=template&id=0a8944e2&scoped=true&ts=true"
import script from "./SearchCategoryTitle.vue?vue&type=script&lang=ts"
export * from "./SearchCategoryTitle.vue?vue&type=script&lang=ts"

import "./SearchCategoryTitle.vue?vue&type=style&index=0&id=0a8944e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a8944e2"]])

export default __exports__